import { 
    CATEGORYAVAILABLE_BEGIN,
    CATEGORYAVAILABLE_ADD,
    CATEGORYAVAILABLE_FAILURE,
    CATEGORYAVAILABLE_CLEAR
} from 'app/actions/CategoryAvailableActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function CategoryAvailableReducer (state = initialState, action) {
	switch (action.type) {
        case CATEGORYAVAILABLE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case CATEGORYAVAILABLE_ADD: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
        case CATEGORYAVAILABLE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case CATEGORYAVAILABLE_CLEAR:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false
            }
		default:
			return state;
	}
};

export const getCategoryAvailable = state => {
	return state.allIds.map( id => state.byId[id] );
}